import React, { Component } from 'react';
import Switch from 'react-switch';

class SwitchButton extends Component {
  constructor() {
    super();
    this.state = { checked: false };
    this.handleChange = this.handleChange.bind(this);
  }
 
  handleChange(checked) {
    this.setState({ checked });
  }
 
  render() {
    return (
      <label htmlFor="normal-switch">
        <Switch
          checked={this.state.checked}
          onChange={this.handleChange}
          onColor="#c4dffa"
          onHandleColor="#4593ea"
          offColor="#c1c1c1"
          handleDiameter={25}
          uncheckedIcon={false}
          checkedIcon={false}
          boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
          activeBoxShadow="0px 0px 5px 10px rgba(0, 0, 0, 0.2)"
          height={12}
          width={40}
          className="react-switch"
          id="material-switch"
        />
      </label>
    );
  }
}

export default SwitchButton;
